import { Email } from './utils/String';

export enum RelationshipState {
  CONNECTED = 'CONNECTED',
  WAITING_TABLET_ACCEPTANCE = 'WAITING_TABLET_ACCEPTANCE',
  WAITING_WEB_USER_ACCEPTANCE = 'WAITING_WEB_USER_ACCEPTANCE',
}

export type Relationship = {
  id: string;
  channel: string;
  created: number;
  email: string;
  state: RelationshipState;
  uuid: string;
  mainUser: {
    emails: Email[];
  };
  user: {
    familyAccess: boolean;
    mainUserAccess: boolean;
  } | null;
};